<template>
  <div class="detail">
    <pl-wrapper
      :loading="!ditailIsReady"
      :error="detailError">
      <template v-if="detail">
        <header>
          <h2 class="title">{{detail.title}}</h2>
          <span class="time">{{detail.lastModifiedTs}}</span>
        </header>
        <div class="content ql-editor" v-html="detail.content" />
      </template>
    </pl-wrapper>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      ditailIsReady: false,
      detail: null,
      detailError: null,
    };
  },
  mounted() {
    const { id } = this.$route.params;
    this.requestGetRecruitmentDetail(id)
      .then(data => {
        this.detail = data;
        this.detailError = null;
        this.ditailIsReady = true;
      })
      .catch(err => {
        this.detailError = err;
        this.ditailIsReady = true;
      })
  },
  methods: {
    ...mapActions('homepage', [
      'requestGetRecruitmentDetail',
    ]),
  },
}
</script>
<style lang="less" scoped>
  @import url('~@/assets/styles/vars.less');

  .detail {
    margin-top: @margin-normal;
    header {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-bottom: @padding-normal;
      border-bottom: 1px solid @color-border;
      .title {
        margin: 0;
        font-size: @font-large;
        color: @color-text-title;
      }
      .time {
        margin-top: @margin-small;
        font-size: @font-small;
        color: @color-text-normal;
      }
    }
    .content {
      margin-top: @margin-normal;
      padding: 0 40px;
      font-size: @font-normal;
      color: @color-text-normal;
      word-break: break-all;
    }
  }
</style>
